import React, { useState } from "react";
import styled from "styled-components";

import emailjs from "emailjs-com";
import SuccessModal from "./SuccessModal";

export const sendEmail = (e) => {
  e.preventDefault();

  emailjs
    .sendForm(
      "service_p7zwf9g",
      "template_mwobl3b",
      e.target,
      "LH1T0k5gxdDcTz8a5",
    )
    .then(
      (result) => {
        console.log("Email sent:", result.text);
      },
      (error) => {
        console.log("Error:", error.text);
      },
    );

  e.target.reset();
};

const AssociateForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    segment: "",
    location: "",
    company_name: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFormSubmission = (event) => {
    event.preventDefault();
    sendEmail(event);
    setIsModalOpen(true);
    setFormData({
      name: "",
      email: "",
      mobile: "",
      segment: "",
      location: "",
      company_name: "",
    });
  };

  return (
    <>
      <FormWrapper>
        <Header>
          <h6>Contact Us</h6>
          <h1>
            Get <span>Connected</span> In Minutes!
          </h1>
        </Header>

        <StyledForm onSubmit={handleFormSubmission}>
          <FormContent>
            <FormGroup>
              <InputWrapper>
                <StyledInput
                  type="text"
                  id="name"
                  placeholder=" "
                  name="user_name"
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  value={formData.name}
                  required
                />
                <StyledLabel htmlFor="name">Name</StyledLabel>
              </InputWrapper>
            </FormGroup>

            <FormGroup>
              <InputWrapper>
                <StyledInput
                  type="email"
                  id="email"
                  name="user_email"
                  placeholder=" "
                  required
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  value={formData.email}
                />
                <StyledLabel htmlFor="email">Email</StyledLabel>
              </InputWrapper>
            </FormGroup>

            <FormGroup>
              <InputWrapper>
                <StyledInput
                  type="text"
                  id="mobile"
                  name="user_mobile"
                  placeholder=" "
                  required
                  onChange={(e) => {
                    setFormData({ ...formData, mobile: e.target.value });
                  }}
                  value={formData.mobile}
                />
                <StyledLabel htmlFor="mobile">Mobile</StyledLabel>
              </InputWrapper>
            </FormGroup>

            <FormGroup>
              <InputWrapper>
                <StyledInput
                  type="text"
                  id="location"
                  name="user_location"
                  placeholder=" "
                  required
                  onChange={(e) => {
                    setFormData({ ...formData, location: e.target.value });
                  }}
                  value={formData.location}
                />
                <StyledLabel htmlFor="location">Location</StyledLabel>
              </InputWrapper>
            </FormGroup>

            <FormGroup>
              <InputWrapper>
                <StyledInput
                  type="text"
                  id="company_name"
                  name="user_company_name"
                  placeholder=" "
                  required
                  onChange={(e) => {
                    setFormData({ ...formData, company_name: e.target.value });
                  }}
                  value={formData.company_name}
                />
                <StyledLabel htmlFor="company_name">
                  Company Name(if any)
                </StyledLabel>
              </InputWrapper>
            </FormGroup>

            <FormGroup>
              <InputWrapper>
                <StyledInput
                  type="text"
                  id="segment"
                  name="user_segment"
                  placeholder=" "
                  required
                  onChange={(e) => {
                    setFormData({ ...formData, segment: e.target.value });
                  }}
                  value={formData.segment}
                />
                <StyledLabel htmlFor="segment">
                  Enter the Segment(s) You Deal In
                </StyledLabel>
              </InputWrapper>
            </FormGroup>
            <input
              type="hidden"
              name="time"
              value={new Date().toLocaleString()} // Current date + time
            />
          </FormContent>

          <SubmitButton type="submit">Submit</SubmitButton>
        </StyledForm>
      </FormWrapper>
      {isModalOpen && <SuccessModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};

export default AssociateForm;

// ============== Styled Components ==============

const FormWrapper = styled.div`
  /* height: 100%; */
  max-width: 700px;
  margin: 0 auto;
  padding: 60px 20px;
  /* background: #e9ecef; */
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.06);
  span {
    color: #fdc500;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h6 {
    font-size: 14px;
    color: #005f73;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }

  h1 {
    font-size: 28px;
    margin-bottom: 10px;
    color: #222;
  }

  p {
    color: #555;
    font-size: 1.1rem;
    max-width: 500px;
    margin: 0 auto;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

const FormContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FormGroup = styled.div`
  position: relative;

  &.full-width {
    grid-column: 1 / -1;
  }
`;

const InputWrapper = styled.div`
  position: relative;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 20px 14px 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: transparent;
  transition: border 0.3s;

  &:focus {
    border-color: #005f73;
    outline: none;
  }

  &:focus + label,
  &:not(:placeholder-shown) + label {
    top: 8px;
    left: 12px;
    font-size: 12px;
    color: #005f73;
    padding: 0 4px;
  }
`;

const StyledLabel = styled.label`
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  background: transparent;
  transition: 0.2s ease all;
  pointer-events: none;
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 16px 0;
  background: linear-gradient(135deg, #005f73, #00c389);
  color: #fff;
  font-size: 17px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition:
    background 0.3s,
    transform 0.2s;

  &:hover {
    background: linear-gradient(135deg, #005f73, #00c389);
    transform: translateY(-2px);
  }
`;
